module.exports = __webpack_public_path__ + "img/hobs.bb9dac7f.png";